export function formatTokenValue(amount, { decimals = 18, fixed = 6 } = {}) {
  const divisor = Math.pow(10, decimals);
  const result = parseFloat(amount) / divisor;
  return result.toFixed(fixed);
}